import { render, staticRenderFns } from "./ImportGiftcardFormPopup.vue?vue&type=template&id=66cb7350"
import script from "./ImportGiftcardFormPopup.vue?vue&type=script&lang=js"
export * from "./ImportGiftcardFormPopup.vue?vue&type=script&lang=js"
import style0 from "./ImportGiftcardFormPopup.vue?vue&type=style&index=0&id=66cb7350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports